import React, { FC, ReactNode } from 'react'
import styles from 'styles/components/accordion.module.scss'

type Props = {
  children: ReactNode
}

const AccordionWrapper: FC<Props> = (props) => {
  const { children } = props
  return <div className={styles.accordion__wrapper}>{children}</div>
}

export default AccordionWrapper
